/*
 * @Descripttion:
 * @version:
 * @Author: susj
 * @Date: 2020-09-14 17:45:16
 * @LastEditors: yinj
 * @LastEditTime: 2021-01-18 09:42:04
 */
import { Icon } from 'ant-design-vue';
import Vue from 'vue';

const IconFont = Icon.createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/font_2053718_pmt6ntnw6x.js',
});
Vue.component('icon-font', IconFont);
